import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./assets/css/margins-paddings.css";
import VersionMain from "./components/pages/version-main";

import AOS from "aos";
import { useEffect } from "react";
import "./assets/css/aos.css";
import footerData from "./data/footer.json";
import headerData from "./data/header.json";
import NewsletterArchive from "./components/pages/newsletter-archive";
import NewsletterPost from "./components/pages/newsletter-post";
import MetaAdLanding from "./components/pages/meta-ad-landing";
import StoneHeartLanding from "./components/pages/stone-heart-landing";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  const { header, headerv3 } = headerData;
  const { footer } = footerData;
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="section-wrapper">
      <div></div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<VersionMain header={header} footer={footer} />} />
          <Route
            path="newsletter-archive"
            element={<NewsletterArchive headerv3={headerv3} footer={footer} />}
          />
          <Route
            path="newsletter-post"
            element={<NewsletterPost headerv3={headerv3} footer={footer} />}
          />
          <Route
            path="adlanding"
            element={<MetaAdLanding footer={footer} />}
          />
          <Route
            path="stone-heart"
            element={<StoneHeartLanding footer={footer} />}
          />
          <Route
            path="stoneheart"
            element={<StoneHeartLanding footer={footer} />}
          />
          <Route
            path="stoneheart-landing"
            element={<StoneHeartLanding footer={footer} />}
          />
          <Route
            path="stoneheart-ad"
            element={<StoneHeartLanding footer={footer} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
